import gmx_zMixins         from '../../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_LocalValues          from './set_LocalValues'
import lmx_Watching             from './Watching'
import lmx_Events               from './Events'

import lmx_Elements       from './Draw_Elements.mixin'          // Common functions for Drawing the Charts
// Charting
import lmx_VNormal   from './Chart_Vertical_Nomal.mixin'
import lmx_HNormal from './Chart_Horizontal_Normal.mixin'
import lmx_VStack   from './Chart_Vertical_Stack.mixin'
import lmx_VGroup   from './Chart_Vertical_Group.mixin'

export default {
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_LocalValues,
    lmx_Watching,
    lmx_Events,
    
    // Charting Mixins

    lmx_Elements,
    
    lmx_VNormal,
    lmx_HNormal,
    lmx_VStack,
    lmx_VGroup,

  ],
}
